import React from 'react';
import { ContextMenuRender, getContextMenuConfig } from '../types';

export const ContextMenuStore = React.createContext<{
    ContextMenuRender?: ContextMenuRender;
    getContextMenuConfig?: getContextMenuConfig<any>;
    onAddRows?: (targetRow: any) => void;
    onDeleteRow?: (row: any) => void;
    onRowReorder?: (sourceRowIndex: number, targetRowIndex: number) => void;
    enableAddAction?: boolean;
    enableRowRecord?: boolean;
    enableRowTools?: boolean;
    readonly?: boolean;
}>({
    ContextMenuRender: undefined,
    getContextMenuConfig: undefined
});
